import React from "react";
import { Chip } from "@material-ui/core";
import { useStyles } from "./styles";
import clsx from "clsx";
import PropTypes from "prop-types";

const modes = {
  void: "error",
  backout: "warning",
  backout_with_ticket: "warning",
  active: "success",
  created: "success",
  payment: "info",
  exit: "info",
  enter: "info",
  selected: "primary",
  unselected: "grey",
  green: "success",
  red: "error",
  info: "info",
  warning: "warning",
};

const SquareChip = ({
  id,
  className,
  text,
  uppercase,
  mode,
  onClick,
  ...props
}) => {
  const classes = useStyles({ modes, mode });

  const handleChipClick = () => {
    if (onClick) {
      onClick(id);
    }
  };

  return (
    <Chip
      {...props}
      className={clsx(className, classes.root, classes.square)}
      label={uppercase === true ? text.toUpperCase() : text}
      clickable={onClick !== undefined}
      onClick={handleChipClick}
    />
  );
};

SquareChip.defaultProps = {
  uppercase: false,
  onClick: undefined,
};

SquareChip.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  uppercase: PropTypes.bool,
  onClick: PropTypes.func,
};

export default SquareChip;
